
const state = {
  id: null,
  label: '',
  link_type: '',
  linkable_id: undefined,
  linkable_type: '',
  url: '',
}

export const requiredFields = [
  { key: 'linkable_type' },
  { key: 'link_type' },
  { key: 'url' },
]

export default state
